type Environment = 'DEV' | 'STG' | 'QA' | 'PROD';
type AuthenticationType = 'oidc' | 'api-key' | 'none';

export type Config = {
    name: string;
    version?: string;
    env: Environment;
    authUrl: string;
    authClientId: string;
    authSilentRefreshPage: string;
    igpGraphQlHttpUrl: string;
    igpGraphQLWsUrl: string;
    igpGraphQlAuthType: AuthenticationType;
    igpGraphQlApiKey: string;
    countriesApiUrl: string;
};

export const defaultConfig: Config = {
    env: 'DEV',
    name: 'admin-panel',

    authUrl: 'https://keycloak.dev.wpto.a5-labs-cloud.com/realms/agent-bo',
    authClientId: 'wpt-agent-bo',
    authSilentRefreshPage: 'silent-refresh.html',
    igpGraphQlHttpUrl: 'https://pam-gql.dev.wpto.a5-labs-cloud.com',
    igpGraphQLWsUrl: 'wss://pam-gql.dev.wpto.a5-labs-cloud.com',
    igpGraphQlAuthType: 'oidc',
    igpGraphQlApiKey: 'da2-mdllpoqjpbf6dlszmwnjdnrlom',
    countriesApiUrl: 'https://countries.dev.wptg.a5-labs-cloud.com',
};

declare const __APP_VERSION: string;
declare const __APP_NAME: string;

class GlobalConfig {
    config: Config = defaultConfig;
    notDefinedYet = true;

    public getConfig(): Config {
        if (this.notDefinedYet) {
            try {
                this.config = (window as unknown as {__env: Config})?.__env ?? defaultConfig;
                this.config.name = __APP_NAME;
                this.config.version = __APP_VERSION;
            } catch {
                // For test environment
                this.config = defaultConfig;
            }
        }

        return this.config;
    }
}

export const globalConfig = new GlobalConfig();
